/**
 * `email_source` values that auto-open the schedule-tour flow on the unit page.
 *
 * Two surfaces read this list: the server component decides whether to
 * auto-trigger, and UnitActionButtons strips the param once the flow is open. A
 * value added to one and not the other still opens the tour but leaves the param
 * in the URL, so it fires again on every refresh — and on any copy of that link.
 */
const TOUR_AUTO_TRIGGER_EMAIL_SOURCES: readonly string[] = [
  'instant-alerts',
  'instant-alerts-schedule-tour',
];

/** Accepts the raw search param, which Next can hand over as an array. */
export function isTourAutoTriggerEmailSource(value?: string | string[] | null): boolean {
  const source = Array.isArray(value) ? value[0] : value;
  return Boolean(source && TOUR_AUTO_TRIGGER_EMAIL_SOURCES.includes(source));
}
